import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { RepairAwaitingModalComponent } from '../repair-awaiting-modal/repair-awaiting-modal.component';
import { RefundWalletYoutubeModalComponent } from '../refund-wallet-youtube-modal/refund-wallet-youtube-modal.component';

@Component({
  selector: 'app-choose-compensate-youtube-modal',
  templateUrl: './choose-compensate-youtube-modal.component.html',
  styleUrls: ['./choose-compensate-youtube-modal.component.scss'],
})
export class ChooseCompensateYoutubeModalComponent {
  index = 1;
  constructor(
    protected dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ChooseCompensateYoutubeModalComponent>
  ) {}

  changeIndex(i: number) {
    this.index = i;
  }

  waitRepairTime() {
    this.dialogRef.close();
    this.dialog.open(RepairAwaitingModalComponent, {
      width: '600px',
      data: Object.assign({}, this.data),
      panelClass: 'app-dialog',
    });
  }

  refund() {
    this.dialogRef.close();
    this.dialog.open(RefundWalletYoutubeModalComponent, {
      width: '570px',
      data: Object.assign({}, this.data),
      panelClass: 'app-dialog',
    });
  }
}
